import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { Page } from '../../components/page';
import {
  fromOrder,
  useAppDispatch,
} from '../../store';
import { useQuery } from '../../routes';
import { PendingOrderHistory } from './component/PendingOrderHistory';
import { PreviousOrderHistory } from './component/PreviouseOrderHistory';
import { EmptyOrderDetails } from './component/EmptyOrderDetails';

export const Order = () => {
  const dispatch = useAppDispatch();
  const { get } = useQuery();
  const accountId = Number(get('accountId'));
  const pendingOrders = useSelector(fromOrder.selectPendingOrder);
  const previousOrders = useSelector(fromOrder.selectPreviousOrder);
  const hasOrder = pendingOrders.length > 0 || previousOrders.length > 0;
  const fetchData = async () => {
    if (accountId) {
      await Promise.all([
        dispatch(fromOrder.doFetchAllOrder(accountId)),
      ]);
    }
  };

  return (
    <Page
      id="order-history"
      headerId="page.order.history.header"
      fetchData={fetchData}
    >
      <Box
        id="order-history-container"
        display="flex"
        flexDirection="column"
        height="100%"
      >
        {hasOrder
          ? (
            <>
              {pendingOrders.length > 0
                && (
                  <PendingOrderHistory
                    key="pending-order-history"
                    pendingOrders={pendingOrders}
                  />
                )}
              {previousOrders.length > 0
                && (
                  <PreviousOrderHistory
                    key="previous-order-history"
                    previousOrders={previousOrders}
                  />
                )}
            </>
          )
          : (
            <EmptyOrderDetails
              key="empty-order-history"
            />
          )}
      </Box>
    </Page>
  );
};
